import { createContext, useState, useEffect, useCallback } from 'react';

const API_URL = process.env.APP_API_URL || 'https://www.sanatandharmmahasabha.com/api/admin';
const AUTH_API_URL = process.env.APP_AUTH_URL || 'https://www.sanatandharmmahasabha.com';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(sessionStorage.getItem('token') || localStorage.getItem('token'));

  console.log("Using API URL:", API_URL);
  console.log("Using Auth URL:", AUTH_API_URL);

  // Initialize user from localStorage on app start
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const initializeAuth = async () => {
      const storedToken = sessionStorage.getItem('token') || localStorage.getItem('token');
      const storedUser = sessionStorage.getItem('user') || localStorage.getItem('user');
      const rememberMe = localStorage.getItem('rememberMe');

      if (storedToken && storedUser) {
        try {
          setUser(JSON.parse(storedUser));
          setToken(storedToken);
        } catch (e) {
          logout();
        }
      }

      else if (storedToken && rememberMe === 'true') {
        try {
          setToken(storedToken);
          await verifyToken(storedToken);
        } catch (e) {
          logout();
        }
      }

      if (storedToken && (rememberMe === 'true' || storedUser)) {
        try {
          if (storedUser) {
            setUser(JSON.parse(storedUser));
          }
          setToken(storedToken);
        } catch (e) {
          console.error("Failed to parse stored user:", e);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          localStorage.removeItem('rememberMe');
        }
      }
      setLoading(false);
    };

    initializeAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Verify token validity with backend
  const verifyToken = useCallback(async (authToken) => {
    try {
      const res = await fetch(`${AUTH_API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({}), // Empty body just to verify token
      });

      if (res.ok) {
        const data = await res.json();
        if (data.admin) {
          setUser(data.admin);
          localStorage.setItem('user', JSON.stringify(data.admin));
          return true;
        }
      }
      
      // Token is invalid or expired
      return false;
    } catch (error) {
      console.error("Token verification failed:", error);
      return false;
    }
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('token');
    localStorage.removeItem('rememberMe');
    localStorage.removeItem('user');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
  }, []);

  const login = async (credentials, rememberMe = false) => {
    try {
      const res = await fetch(`${AUTH_API_URL}/api/admin/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      const data = await res.json();

      if (res.ok && data.admin) {
        setUser(data.admin);
        setToken(data.token);
        
        // Store user data if remember me is checked
        if (rememberMe) {
          localStorage.setItem('token', data.token);
          localStorage.setItem('rememberMe', 'true');
          localStorage.setItem('user', JSON.stringify(data.admin));
        } else {
          localStorage.removeItem('rememberMe');
          localStorage.removeItem('user');
          sessionStorage.setItem('token', data.token);
          sessionStorage.setItem('user', JSON.stringify(data.admin));
        }
        
        return { success: true, admin: data.admin, token: data.token };
      } else {
        return { success: false, message: data.message || 'Login failed' };
      }
    } catch (error) {
      console.error("Login error:", error);
      return { success: false, message: 'Network error. Please try again.' };
    }
  };


  // Export token for API calls
  const getToken = () => token || localStorage.getItem('token');

  return (
    <AuthContext.Provider value={{ 
      user, 
      token: getToken(),
      login, 
      logout, 
      verifyToken,
      loading 
    }}>
      {children}
    </AuthContext.Provider>
  );
};